export default {
  namespaced: true,
  plane: {
    title: "Plano",
    add: "Adicionar",
    name: "Nome",
    instructions: "Instruções",
    devices: "Dispositivos",
    maintenance: "Manutenção",
    maintenance_partial: "Em manutenção parcial",
    maintenance_total: "Em manutenção total",
    image: "Arraste uma imagem",
    add_device: "Para texto ou dispositivo para adicionar ao plano",
    move_plane: "Segure para mover o avião",
    rotate_device: "Pressione e segure para girar o dispositivo",
    no_floor_plant: "Você não tem planta baixa para esta instalação",
    no_floor_plant_permission: "Você não tem permissão para ver as plantas desta instalação",
    floor_plant_load_error: "Não foi possível carregar as plantas desta instalação",
    floor_plant_context_missing: "Não foi possível identificar a instalação do alarme",
    button_text: "Clique aqui para configurar uma planta baixa para esta instalação",
  },
}
